import { render } from "./UserGuide.vue?vue&type=template&id=712c71a0&scoped=true"
const script = {}

import "./UserGuide.vue?vue&type=style&index=0&id=712c71a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712c71a0"]])

export default __exports__